import _ from '@lodash';
import 'ag-grid-enterprise';
import Icon from '@material-ui/core/Icon';
import { useEffect, useState, useRef } from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import { makeStyles } from '@material-ui/core/styles';
import useRouter from '@fuse/hooks/useRouter';
import axios from "@fuse/utils/axios";
import { AgGridReact } from 'ag-grid-react';
import { Button } from '@material-ui/core';
import useToast from '@fuse/hooks/useToast'
import { useDispatch, useSelector } from 'react-redux'
import { setfilterlist, setrowGroupModel } from '../store/filterParamsReducer';
import 'styles/ag-grid-header-style.css';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'ag-grid-community/styles/ag-theme-material.css';
import AgGridFilterGroupView from '@fuse/components/AgGridFilterGroupView';
import CustomFilter from '@fuse/components/AgGridFilterGroupView/components/CustomFilter';
import { dateReformatTo_mmm_dd_yyyy } from '@fuse/utils/dateOperations';

const useStyles = makeStyles({
	layoutRoot: {},
	head: {
		position: "sticky",
		top: 0
	},
	root: {
		// minWidth: 275,
	},
	title: {
		fontSize: 14,
	},
	pos: {
		marginBottom: 12,
	},
	cardGen: {
		width: '20%',
		height: "100%"
	},
	searchbar: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'flex-end',
		margin: '5px 5px 5px 0',
		height: '28px'
	},
	activeTab: {
		background: "rgba(107, 44, 87, 0.04);",
		borderRadius: "0",
	},
	buttonSquare: {
		borderRadius: '5px'
	},
	btn: {
		background: "#30C90A",
		width: "120px",
		borderRadius: "17px",
		color: "#fff"
	},
	icon: {
		fontSize: "18px",
		color: "#61656F",
		display: "inline-block"
	}
});

function ListView(props) {
	const table_name = "ARCHIVED_ASSETS";
	const classes = useStyles();
	const transform_words = {
		id: 'ID',
		sku: 'SKU',
		eol: 'EOL',
		eosl: 'EOSL',
		no: 'No.'
	};

	const [open, setOpen] = useState(false);
	const [fullWidth, setFullWidth] = useState(true);
	const [maxWidth, setMaxWidth] = useState('lg');
	const [tabState, setTabState] = useState("information");
	const router = useRouter()
	const dispatch = useDispatch();
	const toast = useToast(dispatch)
	const [gridApi, setGridApi] = useState(null);
	const gridRef = useRef();
	const skipHeader = [
		'id', 'model_id', 'shipping_location_details', 'status_value', 'contract_header', 'contract_tag_color',
		'assigned_user_details', 'source', 'portal', 'asset_type',
		'purchase_price', 'purchase_date', 'install_date', 'order_number', 'contract_no',
		'sku', 'make', 'city', 'eol', 'eosl', 'service_id', 'warranty_end_date',
		'name', 'sub_category', 'original_info', 'image_name', 'contract_status_value'
	]
	const [displayButton, setDisplayButton] = useState(false);
	const [statusMenu, setStatusMenu] = useState([])
	const [assetId, setAssetId] = useState(null)

	const [rowGroupPanelShow, setRowGroupPanelShow] = useState('never');
	const [tabValue, setTabValue] = useState(0)
	const [groupByArr, setGroupByArr] = useState([])
	const [logs, setLogs] = useState([]);
	const [filterApplied, setFilterApplied] = useState(false);

	const [windowHeight, setWindowHeight] = useState(window.innerHeight - 330);
	const query_data = useSelector(
		(state) => state.reportApp.reportViewDialogReducer.quick_filter
	);
	function TabButton(props) {
		const { activeClass, tab, tabState, tabStateChange, ...restProps } = props;
		const isActive = tab === tabState;
		return (
			<Button
				{...restProps}
				onClick={() => tabStateChange(tab)}
				className={restProps.className && isActive ? activeClass : ""}
			>
				{props.children}
			</Button>
		)
	}

	function Close() {
		setOpen(false)
		setTabState('information')
	}

	function TabContainer(props) {
		const { tabState, tab } = props;
		const shouldRender = tab === tabState;
		return shouldRender ? props.children : <></>
	}

	const generateHeaderLabel = (header) => {
		if (header === 'serial_no') {
			return 'Serial Number'
		}
		if (header === 'model') {
			return 'Model Name'
		}
		if (header === "location_name") {
			return "Location";
		}

		if (header === "user_name") {
			return "User";
		}

		if (header === "mac_id") {
			return "Mac Address";
		}

		return header.split('_').map(word => {
			if (word in transform_words) return transform_words[word];
			return word.charAt(0).toUpperCase() + word.substring(1)
		}).join(' ')
	}

	const handleClickOpen = (asset_id) => {
		router.push(`/archived-assets/${asset_id}`)
	};

	const handleRestore = (asset_id) => {
		axios.delete(`assets/restore-asset/${asset_id}`).then((res) => {
			props.fetchAssets()
			toast.success(res.data.message)
		}).catch(err => {
			console.log('err', err);
			toast.error(err.response.data.message)
		})
	}

	function formatString(str) {
		if (!str) return ''
		return str.split('_').map(word => word.charAt(0).toUpperCase() + word.substring(1)).join(' ')
	}

	function cellStyle(params) {
		return { color: params.data?.status_value?.status_color?.code }
	}

	const onGridReady = (params) => {
		gridRef.current = params;
		setGridApi(params);
		props.endUsersAccounts.forEach((list) => {
			for (const [fieldName, value] of Object.entries(list)) {
				if (value === '-') list[fieldName] = `No ${formatString(fieldName)}`
			}
		})
		if (router.query.report_name === undefined) {
			loadInitialState(params)
			dispatch(setfilterlist({}));
			dispatch(setrowGroupModel([]));
		}
	}

	const onColumnMoved = (params) => {
		if (router.query.report_name === undefined) {
			const rows = params.api?.getColumnState();
			saveView(rows);
		}
	}

	const onColumnPinned = (params) => {
		if (router.query.report_name === undefined) {
			const rows = params.api?.getColumnState();
			saveView(rows);
		}
	}

	function onColumnVisible(params) {
		const rows = params.api?.getColumnState();
		const total_no_of_columns = rows.length;
		let total_hidden_columns = 0;
		rows.forEach(row => {
			const { hide } = row;
			if (hide) {
				++total_hidden_columns;
			}
		});
		if (total_hidden_columns < total_no_of_columns) {
			if (router.query.report_name === undefined) {
				saveView(rows);
			}
		}
	}

	const onRangeSelectionChanged = (params) => {

		let columnCount = 0;
		let startRowIndex = 0;
		let endRowIndex = 0;

		const rows = params.api.getCellRanges();

		if (rows.length != 0) {
			columnCount = params.api.getCellRanges()[0].columns.length;
			startRowIndex = params.api.getCellRanges()[0].startRow.rowIndex;
			endRowIndex = params.api.getCellRanges()[0].endRow.rowIndex;
		}

		if (columnCount > 1 || startRowIndex != endRowIndex) {
			setDisplayButton(true);
		} else {
			setDisplayButton(false);
		}
	}

	function onFilterChanged(event) {
		const rows = event.api.getFilterModel();
		const { filterModelArr } = gridRef.current
		// to show No result found in column filter
		dispatch(setfilterlist(rows));
		saveView("N/A", rows, filterModelArr)

		// validation for no-overlay 
		const total_rows = event.api.getDisplayedRowCount();
		if (total_rows === 0) {
			event.api.showNoRowsOverlay();
		} else {
			event.api.hideOverlay();
		}
	}
	function onSortChanged(params) {
		if (router.query.report_name === undefined) {
			const rows = params.api?.getColumnState();
			saveView(rows);
		}
	}

	function onColumnRowGroupChanged(event) {
		if (router.query.report_name === undefined) {
			const rows = event.api?.getColumnState();
			const first_row = rows[1];
			if (first_row.colId !== 'ag-Grid-AutoColumn') {
				dispatch(setrowGroupModel([]));
				saveView(rows);
			} else {
				dispatch(setrowGroupModel(rows));
			}
		}
		const api = event?.api;
    if (!api) return;
    const groupedColumns = api.getRowGroupColumns();
    if (groupedColumns.length === 0) setGroupByArr([]);
    else setGroupByArr(groupedColumns);
	}

	function saveView(rows, filter, filterModelArr = null) {
		let payload = {}
		if (rows === 'N/A') {
			payload = {
				filter: JSON.stringify(filterModelArr ?? filter),
				table_name
			}
		} else {
			payload = {
				order: JSON.stringify(rows),
				table_name
			}
		}
		// const order = JSON.stringify(rows);
		axios.post('/user-view/save-view-order', payload)
			.then(() => {
				console.log('view updated')
			})
			.catch(err => {
				console.log(err);
			})
	}

	function loadInitialState(params) {
		axios.get(`/user-view/show-view-order?table_name=${table_name}`)
			.then(results => {
				const { data } = results.data;
				if (data !== null) {
					const order = JSON.parse(data.order);
					const filter = JSON.parse(data.filter);
					gridRef.current = { ...gridRef.current, filterModelArr: filter }
					params?.api?.applyColumnState({ state: order });
					params?.api.setFilterModel(filter);
					if (filter && Object.keys(filter)?.length) {
						setFilterApplied(true)
					}
				}
			})
			.catch(err => {
				console.log(err);
			})
	}
	function printSortStateToConsole(params) {
		if (router.query.report_name === undefined) {
			const rows = params.api?.getColumnState();
			saveView(rows);
		}
	}

	// useEffect(()=>{
	// 	gridRef.current.api?.setQuickFilter(
	// 		query_data
	// 	  );
	// },[query_data])

	// useEffect(() => {
	// 	return () => {
	// 			dispatch(setQuickFilter(null))
	// 	}
	// }, [])

	const onFirstDataRendered = (params) => {
		params.api.sizeColumnsToFit(4500);
	};

	const frameworkComponents = {
		customFilter: CustomFilter,
	};

	useEffect(() => {
		if (!router.params?.serial_no) return
		handleClickOpen(router.params.serial_no)
	}, [])

	function handleHideColumnDropDownDesign() {
		if (!groupByArr.length) {
			return {
				display: "inline-flex",
				alignItems: "center",
				justifyContent: "space-between",
				border: "1px solid #000000",
				borderRadius: "20px",
				padding: "3px 10px",
				backgroundColor: "#ffffff",
				lineHeight: "1",
				height: "28px",
				position: "relative",
				cursor: "pointer",
				fontFamily: '"Inter", sans-serif',
				fontSize: "13px",
				fontWeight: 500,
			};
		}
		return {}

	}

	return (
		<>
			<AgGridFilterGroupView
				tableRef={gridRef}
				setRowGroupPanelShow={setRowGroupPanelShow}
				groupByArrFromList={groupByArr}
				tableName="Archived Asset"
				displayTableName="Archived Assets"
			/>
			<div
				className="ag-theme-alpine"
				style={{
					width: "100%",
					height: windowHeight + 165,
					fontSize: '12px'
				}}
			>
				<AgGridReact
					ref={gridRef}
					theme='legacy'
					headerClass="ag-right-aligned-header"
					onFirstDataRendered={onFirstDataRendered}
					suppressRowClickSelection
					onGridReady={onGridReady}
					animateRows
					rowData={props.endUsersAccounts}
					rowHeight={30}
					headerHeight={44}
					// Set the desired sheet name
					defaultExcelExportParams={{
						sheetName: 'Dalos-Source'
					}}
					// no rows overlay 
					overlayNoRowsTemplate="<span>No Result Found</span>"

					// Row Grouping conditions
					showOpenedGroup
					suppressDragLeaveHidesColumns
					suppressMakeColumnVisibleAfterUnGroup
					// autoGroupColumnDef={{ minWidth: 500 }}
					rowGroupPanelShow={rowGroupPanelShow}

					onColumnMoved={onColumnMoved}
					onColumnPinned={onColumnPinned}
					onColumnVisible={onColumnVisible}
					onSortChanged={onSortChanged}
					groupHeaderHeight={1}
					floatingFiltersHeight={40}

					// status bar enabled on range selection
					enableRangeSelection
					statusBar={{
						statusPanels: [
							{
								statusPanel: 'agAggregationComponent'
							},
						],
					}}

					// to check the the no. of rows selected during range selection
					onRangeSelectionChanged={onRangeSelectionChanged}

					onFilterChanged={onFilterChanged}

					// on column group changed
					onColumnRowGroupChanged={onColumnRowGroupChanged}

					cacheQuickFilter

					pagination

					components={frameworkComponents}

					defaultColDef={{
						// flex: 1,
						// minWidth: 180,
						enableRowGroup: true,
						sortable: true,
						resizable: true
					}}
					columnDefs={[
						// ✅ Actions column
						{
							headerName: "Actions",
							suppressMenu: true,          
							suppressHeaderMenuButton: true,
							sortable: false,
							pinned: "right",
							lockPosition: true,
							width: 120,
							minWidth: 120,
							maxWidth: 120,
							suppressSizeToFit: true,
							cellRenderer: ({ data }) => {
								if (!data) return null;
								const canView =
									props.viewAssetPermission === "all" ||
									props.viewAssetPermission.length > 0 ||
									props.viewAssetPermission.some(
										(id) => id === data.location_obj?.id
									);

								if (!canView) return null;

								return (
									<Tooltip id="view" title="View" placement="top">
										<Icon
											onClick={() => handleClickOpen(data.id)}
											fontSize="small"
											style={{
												color: "#1d2939",
												paddingBottom: "3px",
												paddingRight: "30px",
												fontSize: "15px",
												cursor: "pointer",
											}}
										>
											visibility
										</Icon>
									</Tooltip>
								);
							},
						},

						// ✅ Dynamically generated columns
						...Object.keys(props.endUsersAccounts[0] || [])
							.filter((header) => !skipHeader.includes(header))
							.map((header) => {
								const base = {
									field: header,
									headerName: generateHeaderLabel(header),
									minWidth: 200,
									flex: 1,
									sortable: true,
									filter: "agTextColumnFilter",
									headerComponent: (prop) => CustomFilter(prop, header, gridRef),
								};

								// 🔹 Specific render logic by field
								if (header === "contract_tag") {
									return {
										...base,
										cellRenderer: (params) => {
											const color =
												params.data?.contract_tag_color?.code || "#999";
											return (
												<span style={handleHideColumnDropDownDesign()}>
													<span
														style={{
															height: "10px",
															width: "10px",
															borderRadius: "50%",
															display: "inline-block",
															backgroundColor: color,
														}}
													/>
													<span
														style={{
															marginLeft: "5px",
															fontSize: "12px",
															fontWeight: "500",
															color: "black",
															fontFamily: '"Inter", sans-serif',
														}}
													>
														{params.value}
													</span>
												</span>
											);
										},
									};
								}

								if (header === "status") {
									return {
										...base,
										cellRenderer: (params) => {
											const color =
												params.data?.status_value?.status_color?.code;
											const name = params.data?.status_value?.status_name;
											return (
												<span>
													<span
														style={{
															height: "10px",
															width: "10px",
															borderRadius: "50%",
															display: "inline-block",
															backgroundColor: color,
														}}
													/>
													<span style={{ marginLeft: "5px" }}>{name}</span>
												</span>
											);
										},
									};
								}

								if (["created_date", "updated_date"].includes(header)) {
									return {
										...base,
										cellRenderer: (params) => (
											<span>{dateReformatTo_mmm_dd_yyyy(params.value)}</span>
										),
									};
								}

								return base;
							}),
					]}
				/>
			</div>
		</>
	);
}

export default ListView